import React from 'react';
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeTab, setLoading } from '../../actions/general';
import { useTranslation } from 'react-i18next';
import { hasEnPrefix, toLangPath } from '../../utilities/helpers';

export default function OffersTopSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const offerType = useSelector(state => state.general.offerType);
  const { t } = useTranslation();

  const goBack = () => {
    const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
    const path = window.location.pathname;
    dispatch(setLoading(false));

    if (path.includes('offer-user')) {
      navigate(toLangPath('/offers-users', lang));
      return;
    }
    if (path.includes('offer-manufacturer')) {
      navigate(toLangPath('/offers-manufacturers', lang));
      return;
    }
    navigate(toLangPath('/offers', lang));
  };

  return (
    <div className='offers-top-section-wrapper'>
      {offerType === 'manufacturers' && 
          <div className='section-wrapper top'>
            <img src={require('../../assets/icons/arrow-orange.svg').default} alt='arrow' onClick={goBack} />
            <div className='flex start col'>
              <h2>{t('offers.offersHeaderManufacturersTitle')}</h2>
              <p>{t('offers.offersInitialTextOne')}<span className='link'
              onClick={() => {
              dispatch(changeTab('contact'))
              navigate('/contact')
            }}>{t('offers.offersInitialTextTwo')}</span></p>
            </div>
          </div>}

      {offerType === 'users' && 
          <div className='section-wrapper top'>
            <img src={require('../../assets/icons/arrow-orange.svg').default} alt='arrow' onClick={goBack} />
            <div className='flex start col'>
              <h2>{t('offers.offersHeaderUsersTitle')}</h2>
              <p>{t('offers.offersInitialTextOne')}<span className='link' 
              onClick={() => {
              dispatch(changeTab('contact'))
              navigate('/contact')
            }}>{t('offers.offersInitialTextTwo')}</span></p>
            </div>
          </div>}

      {!offerType &&
          <div className='section-wrapper top'>
            <img src={require('../../assets/icons/arrow-orange.svg').default} alt='arrow' onClick={goBack} />
            <div className='flex start col'>
              <h2>{t('general.getOffer')}</h2>
            </div>
          </div>}
    </div>
  )
}
